import React, { useState } from "react";

const NewsletterSubscribe = ({ language }) => {
  const [email, setEmail] = useState("");
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const sub = (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // ✅ Email validation
    if (!email) {
      setError(
        language === "ar"
          ? "يرجى إدخال البريد الإلكتروني"
          : "Please enter your email"
      );
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError(
        language === "ar"
          ? "يرجى إدخال بريد إلكتروني صحيح"
          : "Please enter a valid email address"
      );
      return;
    }

    // ✅ Terms validation
    if (!accepted) {
      setError(
        language === "ar"
          ? "يرجى الموافقة على الشروط والأحكام"
          : "Please agree to the terms & conditions"
      );
      return;
    }

    const googleScriptUrl =
      "https://script.google.com/macros/s/AKfycbx6273Y6inBParKKb8apdHsK3aqNm6VetI8aQge4LI4s6bS9OHYGg7vhfcanGeOk1acCA/exec";

    fetch(googleScriptUrl, {
      method: "POST",
      body: new URLSearchParams({ email }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.result === "success") {
          setSuccess(
            language === "ar"
              ? "تم الاشتراك بنجاح"
              : "Successfully subscribed"
          );
          setEmail("");
          setAccepted(false);
        } else {
          setError(data.error || "Something went wrong");
        }
      })
      .catch(() => {
        setError(
          language === "ar"
            ? "حدث خطأ، حاول مرة أخرى"
            : "Something went wrong, please try again"
        );
      });
  };

  const texts = {
    en: {
      title: "Monthly newsletter",
      description: "Get the best of CaptainX in your inbox.",
      placeholder: "you@domain.com",
      buttonText: "Subscribe now",
      terms: "I agree to the terms & conditions",
    },
    ar: {
      title: "النشرة الشهرية",
      description: "احصل على أفضل ما في CaptainX في صندوق الوارد الخاص بك.",
      placeholder: "أنت@النطاق.com",
      buttonText: "اشترك الآن",
      terms: "أوافق على الشروط والأحكام",
    },
  };

  const { title, description, placeholder, buttonText, terms } =
    texts[language];

  return (
    <div className="card-newssletter my-3" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="px-5 text-center">
        <h5 className="news-card-title">{title}</h5>
        <p>{description}</p>
      </div>

      <form onSubmit={sub}>
        <input
          placeholder={placeholder}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="newsletter-form mb-2"
        />

        {/* ✅ Inline error */}
        {error && <small className="text-danger d-block mb-2">{error}</small>}

        {/* ✅ Inline success */}
        {success && (
          <small className="text-success d-block mb-2">{success}</small>
        )}

        <button className="subscribe-btn w-100">{buttonText}</button>

        <div className="d-flex align-items-center terms-text">
          <input
            type="checkbox"
            className="me-2"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
          />
          <span>{terms}</span>
        </div>
      </form>
    </div>
  );
};

export default NewsletterSubscribe;
